import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const theme = extendTheme({
  fonts: {
    heading: `'Wavehaus', sans-serif;`,
    body: `'Wavehaus', sans-serif;`,
  },
  colors: {
    primary: {
      main: "#6C47FF",
      50: "#dddeff",
      100: "#bcbdff",
      200: "#9e9aff",
      300: "#8374ff",
      400: "#6C47FF",
      500: "#6C47FF",
      600: "#4e32be",
      700: "#321f80",
      800: "#190d48",
      900: "#040216"
    }
  },
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider theme={theme}>
    <App />
  </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
